import styled from 'styled-components';
import { getFontStyle } from '~components/Text/helper';
import { NudgeLoginDialogProps } from '.';

export const MessageWrapper = styled.div<Pick<NudgeLoginDialogProps, 'inlineCss'>>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  display: inline-block;
  padding: 16px 32px;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 4px;

  ${({ theme }) => theme.media.mobile} {
    padding-left: 24px;
    padding-right: 24px;
  }

  ${({ inlineCss }) => inlineCss};
`;

export const Message = styled.div`
  ${getFontStyle('midium150_C1')};
  text-align: center;
`;

export const SubMessage = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.gray700};
  white-space: nowrap;
  margin-bottom: 8px;
  ${getFontStyle('midium150_C2')};
`;

export const ButtonGroup = styled.div`
  margin-top: 8px;
  text-align: center;
`;
